/* Nuvolia — interactions du thème */
(function () {
  'use strict';

  var N = window.Nuvolia || {};
  var S = N.strings || {};

  /* ---------- Couleurs des coloris ---------- */
  var swatches = {};
  (N.swatchesRaw || '').split(/\r?\n/).forEach(function (line) {
    var i = line.indexOf(':');
    if (i > 0) swatches[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
  });
  function setDuvet(name) {
    var c = swatches[(name || '').toLowerCase()];
    if (!c) return;
    document.documentElement.style.setProperty('--duvet', c);
    document.querySelectorAll('[data-product-section]').forEach(function (el) { el.style.setProperty('--duvet', c); });
  }

  /* ---------- Bandeau d'annonce ---------- */
  document.querySelectorAll('[data-rotator]').forEach(function (track) {
    var items = track.children;
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- En-tête ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var navToggle = document.querySelector('[data-nav-toggle]');
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var nav = document.getElementById(navToggle.getAttribute('aria-controls'));
      var open = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
  }

  /* ---------- Panier ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer || !N.cartDrawer) { window.location.href = N.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.querySelector('.drawer__panel').focus();
    });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 350);
    if (lastFocus) lastFocus.focus();
  }

  function refreshCart() {
    var url = window.location.pathname + '?sections=cart-drawer';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        document.querySelectorAll('[data-cart-body]').forEach(function (body) {
          if (fresh) body.innerHTML = fresh.innerHTML;
        });
        var count = doc.querySelector('.drawer__count');
        var current = document.querySelector('.drawer__count');
        if (count && current) current.textContent = count.textContent;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer && N.cartDrawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var change = e.target.closest('[data-line-change]');
    if (change) {
      change.disabled = true;
      fetch(N.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: change.dataset.lineChange, quantity: Number(change.dataset.qty) })
      }).then(refreshCart).catch(function () { change.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  /* ---------- Vidéos ---------- */
  document.querySelectorAll('[data-reel]').forEach(function (reel) {
    var track = reel.querySelector('[data-reel-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.querySelectorAll('.reel__item'));
    var videos = items.map(function (it) { return it.querySelector('video'); });
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = reel.dataset.autoplay === 'true' && !reduce;

    videos.forEach(function (v) {
      if (!v) return;
      v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls');
    });

    if (autoplay && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.intersectionRatio >= 0.6) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: [0, 0.6] });
      videos.forEach(function (v) { if (v) io.observe(v); });
    }

    /* Ouverture en grand, avec le son */
    var modal = reel.querySelector('[data-reel-modal]');
    var slot = reel.querySelector('[data-reel-modal-media]');
    function closeModal() {
      var mv = slot.querySelector('video'); if (mv) mv.pause();
      slot.innerHTML = '';
      if (modal.open) modal.close();
    }
    reel.querySelectorAll('[data-reel-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.parentNode.querySelector('video');
        if (!src || !modal || !modal.showModal) return;
        var v = src.cloneNode(true);
        v.removeAttribute('class'); v.muted = false; v.loop = true; v.controls = true; v.playsInline = true; v.preload = 'auto';
        slot.innerHTML = ''; slot.appendChild(v);
        modal.showModal();
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
    });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('reel-modal__inner')) closeModal(); });
      modal.addEventListener('close', function () { var mv = slot.querySelector('video'); if (mv) mv.pause(); slot.innerHTML = ''; });
      var closeBtn = modal.querySelector('[data-reel-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
    }

    /* Défilement, flèches et points */
    var prev = reel.querySelector('[data-reel-prev]');
    var next = reel.querySelector('[data-reel-next]');
    var dots = Array.prototype.slice.call(reel.querySelectorAll('.reel__dot'));
    function step() { return items[0] ? items[0].getBoundingClientRect().width + 18 : 300; }
    function sync() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      track.classList.toggle('is-centered', !overflow);
      var dotsWrap = reel.querySelector('[data-reel-dots]');
      if (dotsWrap) dotsWrap.hidden = !overflow;
      if (prev) { prev.hidden = !overflow; prev.disabled = track.scrollLeft < 4; }
      if (next) { next.hidden = !overflow; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
      if (dots.length) {
        var idx = Math.round(track.scrollLeft / step());
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) idx = dots.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(idx, dots.length - 1)); });
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- Page produit ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var colorIndex = Number(section.dataset.colorIndex);
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var errorEl = section.querySelector('[data-form-error]');
    var inputs = section.querySelectorAll('.picker__input');

    function selectedOptions() {
      var opts = [];
      inputs.forEach(function (input) {
        if (input.checked) opts[Number(input.dataset.optionIndex)] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }

    function showMedia(id) {
      if (!id) return;
      var target = section.querySelector('[data-media-id="' + id + '"]');
      if (!target) return;
      section.querySelectorAll('[data-media-id]').forEach(function (m) { m.classList.toggle('is-active', m === target); });
      section.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
    }

    function markAvailability(opts) {
      inputs.forEach(function (input) {
        var idx = Number(input.dataset.optionIndex);
        var test = opts.slice(); test[idx] = input.value;
        var match = data.variants.find(function (v) { return v.options.every(function (o, i) { return test[i] === o; }); });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);

      opts.forEach(function (val, i) {
        var cur = section.querySelector('[data-option-current="' + i + '"]');
        if (cur) cur.textContent = val;
      });
      if (colorIndex >= 0) setDuvet(opts[colorIndex]);
      markAvailability(opts);

      if (!v) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = S.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? S.addToCart : S.soldOut; }

      var now = section.querySelector('[data-price-now]');
      var was = section.querySelector('[data-price-was]');
      var save = section.querySelector('[data-price-save]');
      if (now) now.textContent = v.price;
      if (was) { was.hidden = !v.compare; was.textContent = v.compare || ''; }
      if (save) { save.hidden = !v.saving; save.textContent = v.saving ? S.save + ' ' + v.saving : ''; }

      var sv = section.querySelector('[data-sticky-variant]');
      var sp = section.querySelector('[data-sticky-price]');
      if (sv) sv.textContent = v.title;
      if (sp) sp.textContent = v.available ? S.addToCart : S.soldOut;
      if (sv) sv.textContent = v.title + ', ' + v.price;

      showMedia(v.media);

      if (window.history.replaceState && /\/products\//.test(window.location.pathname)) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', update); });
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    /* Quantité */
    var qtyInput = section.querySelector('.qty__input');
    section.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.min(10, Math.max(1, (Number(qtyInput.value) || 1) + Number(btn.dataset.qtyStep)));
        qtyInput.value = next;
      });
    });

    /* Ajout au panier */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        addBtn.disabled = true;
        addLabel.textContent = S.adding;
        fetch(N.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () {
            addBtn.classList.add('is-added');
            addLabel.textContent = S.added;
            return refreshCart().then(openDrawer);
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = (err && err.description) || S.error; errorEl.hidden = false; }
          })
          .finally(function () {
            setTimeout(function () {
              addBtn.classList.remove('is-added');
              update();
            }, 1600);
          });
      });
    }

    /* Barre collante mobile */
    var sticky = section.querySelector('[data-sticky-buy]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var buyVisible = true;
      var sectionVisible = true;
      var sync = function () {
        var show = !buyVisible && sectionVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        sticky.querySelector('[data-sticky-add]').tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        buyVisible = e.isIntersecting || e.boundingClientRect.top > 0;
        sync();
      }).observe(addBtn);
      var footer = document.querySelector('.footer, .closer');
      if (footer) new IntersectionObserver(function (entries) { sectionVisible = !entries[0].isIntersecting; sync(); }).observe(footer);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        if (addBtn.disabled) { section.scrollIntoView({ behavior: 'smooth' }); return; }
        form.requestSubmit ? form.requestSubmit() : addBtn.click();
      });
    }

    update();
  });
})();
